import React, { createContext, useState, useMemo } from "react";
import { node } from "prop-types";
import PersonIcon from "@material-ui/icons/Person";
import PublicIcon from "@material-ui/icons/Public";
import SchoolIcon from "@material-ui/icons/School";
import ClassIcon from "@material-ui/icons/Class";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import HomeIcon from "@material-ui/icons/Home";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AddIcon from "@material-ui/icons/Add";
import ViewListIcon from "@material-ui/icons/ViewList";

const user = [
  {
    value: "home",
    name: "Ana Sayfa",
    icon: <HomeIcon />,
  },
  {
    value: "confirm",
    name: "Liste",
    icon: <ViewListIcon />,
  },
];

const manager = [
  ...user,
  {
    value: "persons",
    name: "Personeller",
    icon: <PersonIcon />,
  },
];

const all = [
  ...manager,
  /*{
    value: "companies",
    name: "Kurum",
    icon: <SchoolIcon />,
  },
  */
];

const initialState = {
  supervisor: all,
  visor: all,
  manager: manager,
  user: user,
};

export const RoleContext = createContext(initialState);

export function RoleStore({ children }) {
  const [state, setState] = useState(initialState);
  const providerState = useMemo(() => ({ state, setState }), [state, setState]);
  return (
    <RoleContext.Provider value={providerState}>
      {children}
    </RoleContext.Provider>
  );
}

RoleStore.defaultProps = {
  children: null,
};

RoleStore.propTypes = {
  children: node,
};
